export default "__VITE_ASSET__41dRLFB4__"